import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { SpinnerService } from '../services/spinner.service';
import { FULLSCREEN_LOADING } from './loading-context';

export const SpinnerInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.context.get(FULLSCREEN_LOADING)) return next(req);
  const spinner = inject(SpinnerService);
  spinner.showFromInterceptor();
  return next(req).pipe(finalize(() => spinner.hideFromInterceptor()));
};